import styled, {css} from "styled-components"

export const OccasionIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 5px;
`

export const SelectWrapper = styled.div`
  margin-bottom: 15px;
`

export const RoundIconWrapper = styled.div`
  ${({theme}) => css`
    display: inline-block;
    width: ${theme.spacing.three};
    height: ${theme.spacing.three};
    border-radius: ${theme.spacing.oneAndHalf};
    padding: 2px;
    background-color: ${theme.colors.utility.white};
    margin-right: ${theme.spacing.one};
  `}
`
